angular.module("app").directive("tchCourseSelector", function () {
	return {
		restrict: "E",
		templateUrl: "common/directives/exploitation/course/tchCourseSelectorDirective.html",
		replace: true,
		scope: {
			data: "=tchCourseSelectorData",
			callback: "&tchCourseSelectorCallback"
		},

		link: function (scope) {

			scope.courseSelected = function () {
				if (scope.callback) {
					scope.callback({course: scope.data.currentCourse});
				}
			};


		}
	};
});
